import { APPOINTMENT_STATUSES } from 'features/order-tracker/utils/entries';

import { ABORTIVE_VISIT_CHARGE_LINK } from '../EngineerVisitSection/components/MissedEngineerVisitAccordion/constants';

export const PONR_DESCRIPTION_ENGINEERING_VISIT = {
  text: 'It’s too late to make changes online. We may be able to help if you chat now, but you may need to pay a ',
  linkUrl: ABORTIVE_VISIT_CHARGE_LINK,
  linkText: 'missed appointment charge.',
};

export const PONR_DESCRIPTION_EXPERT_SETUP = {
  text: 'It’s too late to make changes. We may be able to help if you chat now, but you may need to pay a ',
  linkUrl: ABORTIVE_VISIT_CHARGE_LINK,
  linkText: 'missed appointment charge.',
};

export const AMEND_APPOINTMENT_DISABLED_MESSAGE = [
  'If you need to reschedule your appointment or change your site contact details, please use live chat.',
];

export const AMENDS_IN_PROGRESS_MESSAGE =
  "We've got your request, your new engineer appointment is pending, as soon as we have an update we will be in touch.";
export const KCI2_ASSURE_APPOINTMENT_TEXT =
  'We’ll confirm your engineer appointment with you as soon as we can. The engineer will need to do installation work up to your premise’s outside wall and our supplier will confirm with you when this will take place.';
export const APPOINTMENT_DESCRIPTION_TEXT_BY_STATUS = {
  [APPOINTMENT_STATUSES.Booked]: [''],
  [APPOINTMENT_STATUSES.Confirmed]: ['Anything need changing? Chat to us up to 12noon the day before the appointment.'],
  [APPOINTMENT_STATUSES.AtRisk]: ['Anything need changing? Chat to us up to 12noon the day before the appointment.'],
  [APPOINTMENT_STATUSES.Rejected]: ['Anything need changing? Chat to us up to 12noon the day before the appointment.'],
  [APPOINTMENT_STATUSES.SupplierChanged]: [
    'Anything need changing? Chat to us up to 12noon the day before the appointment.',
  ],
  [APPOINTMENT_STATUSES.CustomerMissed]: ['Missed appointment. Please chat now to book a new one.'],
  [APPOINTMENT_STATUSES.ReAppointEUMissed]: [
    'Missed appointment. To avoid delays, we’ll request the earliest possible replacement automatically, and let you know as soon as it’s booked.',
  ],
  [APPOINTMENT_STATUSES.ReAppointORMissed]: [
    'Missed appointment. To avoid delays, we’ll request the earliest possible replacement automatically, and let you know as soon as it’s booked.',
  ],
  [APPOINTMENT_STATUSES.SupplierMissed]: [
    'Missed appointment. To avoid delays, we’ll request the earliest possible replacement automatically, and let you know as soon as it’s booked.',
  ],
  [APPOINTMENT_STATUSES.SupplierDelayed]: [
    'Sorry, our supplier couldn’t complete your appointment. To finish the work, we’ll request the earliest possible replacement automatically, and let you know as soon as it’s booked.',
  ],
  [APPOINTMENT_STATUSES.Completed]: [''],
  [APPOINTMENT_STATUSES.Closed]: [''],
};

export const APPOINTMENT_DESC_ENGG_VISIT_TEXT_BY_STATUS = {
  ...APPOINTMENT_DESCRIPTION_TEXT_BY_STATUS,
  [APPOINTMENT_STATUSES.Confirmed]: [
    'Anything need changing? Do it online up to 12noon the day before the appointment.',
  ],
  [APPOINTMENT_STATUSES.AtRisk]: ['Anything need changing? Do it online up to 12noon the day before the appointment.'],
  [APPOINTMENT_STATUSES.Rejected]: [
    'Anything need changing? Do it online up to 12noon the day before the appointment.',
  ],
  [APPOINTMENT_STATUSES.SupplierChanged]: [
    'Anything need changing? Do it online up to 12noon the day before the appointment.',
  ],
};
